import { Alert, AlertTitle, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'

// Shown when generating a reserve invoice from the Utilization list is blocked: either the lease has no
// 'Finance Control' working group (or one with no members) set up, or the current user isn't one of its members.
const NoWorkingGroupModal = ({ open, leaseSlug, onClose, isMemberMismatch = false, title = 'Reserve Invoice' }) => {
    if (!open) return null
    return (
        <Dialog open maxWidth='sm' fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                {isMemberMismatch ? (
                    <Alert severity='warning'>
                        <AlertTitle>Invoice creation failed.</AlertTitle>
                        Only Finance Control members are authorized to generate invoices.
                    </Alert>
                ) : (
                    <Alert severity='warning'>
                        <AlertTitle>No Working Group Found</AlertTitle>
                        'Finance Control' working group is missing or has no members added.<br/>   Add it under{' '}
                        <Typography
                            component='span'
                            variant='inherit'
                            sx={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 600 }}
                            onClick={() => window.open(`/lease/${leaseSlug}/lease-details/working-groups`, '_blank')}
                        >
                            Basic Details {'>'} Working Group
                        </Typography>
                        {' '}before generating a {title.toLowerCase()}.
                    </Alert>
                )}
            </DialogContent>
            <DialogActions sx={{ marginRight: '15px' }}>
                <Button size='small' variant="outlined" onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default NoWorkingGroupModal
